// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__2Jkrw","aside":"App_aside__2fSW7","main":"App_main__2l94Q","output":"App_output__11yQC","navlist":"App_navlist__19yCX","navlist__item":"App_navlist__item__3u3LQ"};